/**
 * App entry point
 *
 * - Loads `app.tsx`, which mounts the UI and emits "ui-ready"
 * - Waits for "ui-ready" before loading `main.app.ts` to ensure no events are missed
 * - Emits "load" after receiving the "initialized" event triggered by app.init()
 * - Initializes Sentry in production
 */

import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";

import("./main.app.ui");

emitter.on("ui-ready", () => {
  import("./main.app");  
})

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}
